import { Box, Dialog, DialogTitle, IconButton, styled } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { H3 } from "components/design-system/atoms/Typography";
import Body from "components/design-system/atoms/Typography/Body";
import LocalOfferToggle from "components/design-system/organisms/LocalOfferToggle";
import GreyLeaf from "components/localOffer/assets/grayLeaf.svg";
import React, { FC } from "react";
import theme from "theme";
import ConnectedAdressForm from "../../../localOffer/ConnectedAddressForm";
import { getClientLocalCatalogs, resetEligibility } from "../../../localOfferEligibility/LocalOfferEligibility";
import Button from "../../atoms/Button";
import Arrow from "./../../../localOffer/assets/arrow.svg";

interface LocalOfferDesktopModalProps {
  addCatalogsToRefinementList: () => void;
  removeCatalogsFromRefinementList: () => void;
}

const BackgroundBox = styled(Box)({
  backgroundColor: theme.palette.green,
  color: theme.palette.secondary.main,
  padding: "60px",
});

const BootstrapDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    borderRadius: "20px",
    textAlign: "center",
    maxWidth: "765px",
  },
}));

const CloseButton = styled(IconButton)({
  position: "absolute",
  right: 8,
  top: 8,
});

const SeeOfferButton = styled(Button)({
  marginTop: "16px",
  fontSize: "18px",
  fontWeight: 500,
});

const ButtonWrapper = styled(Box)({
  margin: "auto",
  maxWidth: "76%",
});

const reinsuranceTexts = [
  { normal: "Click & collect", bold: "gratuit" },
  { normal: "Livraison", bold: "48h" },
  { normal: "Soutient", bold: "l'emploi local" },
];

const LocalOfferDesktopModal: FC<LocalOfferDesktopModalProps> = ({
  addCatalogsToRefinementList,
  removeCatalogsFromRefinementList,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleSwitchChange = () => {
    if (getClientLocalCatalogs()?.length > 0) {
      resetEligibility();
      removeCatalogsFromRefinementList();
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <LocalOfferToggle isActivated={getClientLocalCatalogs()?.length > 0} handleChange={handleSwitchChange} />
      <BootstrapDialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <Box position="absolute" left={"-46px"}>
          <Arrow style={{ transform: "matrix(0.48, -0.89, -0.95, -0.5, 0, 0) rotateZ(23deg)" }} />
        </Box>
        <BackgroundBox>
          <DialogTitle>
            <H3>Choisissez un appareil de votre région,&nbsp;plus rapide, et avantageux !</H3>
            <CloseButton aria-label="close" onClick={handleClose}>
              <CloseIcon />
            </CloseButton>
          </DialogTitle>
          <Box display="flex" my={5} justifyContent="center">
            {reinsuranceTexts.map((text, index) => (
              <Box display="flex" mr={4} key={index}>
                <Box minWidth="18px">
                  <GreyLeaf />
                </Box>
                <Box ml={1}>
                  <Body>
                    {text.normal} <span style={{ fontWeight: 600 }}> {text.bold} </span>
                  </Body>
                </Box>
              </Box>
            ))}
          </Box>

          <ButtonWrapper>
            <ConnectedAdressForm
              id={`desktop-modal-local-offer`}
              autoFocusField={true}
              addCatalogsToRefinementList={() => {
                addCatalogsToRefinementList();
                handleClose();
              }}
              vertical={true}
              disabled={false}
            >
              <SeeOfferButton
                type="submit"
                variant="text"
                version="green_and_light_green"
                dimension="jumbo"
                onClick={() => {
                  addCatalogsToRefinementList();
                  handleClose();
                }}
                fullWidth
              >
                Voir les produits régionaux
              </SeeOfferButton>
            </ConnectedAdressForm>
          </ButtonWrapper>
        </BackgroundBox>
      </BootstrapDialog>
    </>
  );
};

export default LocalOfferDesktopModal;
